import React, { useEffect, useRef } from "react"
import useScript from "../Hooks/useScript"
import Footer from "./Footer"
import Header from "./Header"

const Layout = ({ children, location }) => {
  useEffect(() => {
    document.body.classList.add("tech-front")

    return () => {
      document.body.classList.remove("tech-front")
    }
  }, [])
  return (
    <React.Fragment>
      <Header location={location} />
      {children}
      <Footer />
      <div className="hidden !pb-0 !pt-0 md2:mt-70 lg:pb-160 lg:pt-30 xl2:pt-30 !pt-30 lg:py-100 md:pt-100 lg:!pt-100 lg:mt-50 lg:mt-30 lg:mt-60 !pt-70 lg:!pt-115 lg:!pb-75 lg:!pb-80 lg:!pt-65 lg:!pt-80 lg:!pb-120 !pt-20 !pt-10 lg:!pb-110 lg:mt-35 md2:px-40 lg:!pb-100 lg:!pt-125 lg:!pb-85 lg:!mt-10 lg:!pt-90 lg:!pt-60 lg:!py-85 lg:!py-80 lg:!py-90"></div>
    </React.Fragment>
  )
}

export default Layout
